import { Directive, Input, ElementRef, Renderer2 } from '@angular/core';
import { UserService } from '../../services/UserService';
import { PermissionService } from '../../services/PermissionService';
import { User } from '@socrates/common';

/**
 * This directive will hide the associated dom element if the user does not qualify for the
 * argument privilege
 */
@Directive ({
	selector: '[ngshow]',
	standalone: false,
})
export class PrivilegeShowDirective {
	private _loggedInUser: User;
	private _privilege: string;

	constructor(
		private userService: UserService,
		private permissionService: PermissionService,
		private element: ElementRef,
		private renderer: Renderer2
	) {
	}

	@Input() set ngshow(privilege: string) {
		this._privilege = privilege;
		if (!this._privilege) return;

		this._loggedInUser = this._loggedInUser ?? this.userService.getUser();
		if (this._loggedInUser) {
			this.privilegeCheck();
		} else {
			this.userService.checkSession().then((user: User) => {
				this._loggedInUser = user;
				this.privilegeCheck();
			}).catch(() => {});
		}
	}

	private privilegeCheck(): void {
		if (!this._loggedInUser || !this.permissionService.permitted(this._loggedInUser, this._privilege)) {
			this.renderer.setStyle(this.element.nativeElement, 'display', 'none');
		}
	}
}
